import { ReduxState } from '../types';

import { clientId, selectClientInfoData } from 'app/lib/account/selectors';

/**
 * Returns `true` if the client is authorized, `false` otherwise.
 *
 * @param {object} state
 * @return {boolean}
 */
export const selectIsLoggedIn = (
  state: ReduxState,
): boolean => Boolean(selectClientInfoData(state) && clientId(state) !== null);

/**
 * @param {object} state
 * @return {boolean} – `true` if logging in is in process
 */
export const processing = (state: ReduxState): boolean => state.auth.processing;

/**
 * @param {object} state
 * @return {boolean} – `true` if logging in is in process
 */
export const getIsLoginSuccess = (state: ReduxState): boolean => state.auth.isLoginSuccess;

export const selectLoginError = (state: ReduxState): string | null => state.auth.error;

/**
 * @param {object} state
 * @return {boolean} – `true` if logging in is in process
 */
export const getIsLogoutSuccess = (state: ReduxState): boolean => state.auth.isLogoutSuccess;
